const tabLibrary = {};

export function RememberTab(clientId, tabName) {
    tabLibrary[clientId] = tabName;
}

export function GetLastTab(clientId) {
    return tabLibrary[clientId];
}
